/**
 * Разбор ссылки `gg.teamplay.twa://call?…`, которой Android-уведомление открывает приложение.
 *
 * Ссылка несёт не только callId: в data-пуше уже лежат имя звонящего и готовый ресайзнутый адрес
 * аватара, и раньше всё это оставалось в системном уведомлении — приложение знало один callId и
 * добирало лицо вторым запросом к серверу, заметно позже самого экрана звонка.
 *
 * Интент экспортирован, то есть такую ссылку может прислать любое приложение на телефоне, а её
 * содержимое попадает прямо в интерфейс звонка (аватар — ещё и в CSS `url()` на экране ринга).
 * Поэтому имя и адрес просеиваются здесь: callId сверяется с сервером и подделка бесполезна, а вот
 * показать по чужой указке что угодно было бы можно.
 */
const CALL_DEEPLINK_PREFIX = 'gg.teamplay.twa://call';

const SAFE_AVATAR_URL = /^https:\/\/[^\s'"()\\]+$/;
const MAX_NAME_LENGTH = 64;

export type CallAction = 'answer' | 'decline' | 'open';

export type CallLink = {
  callId: string;
  action: CallAction;
  callerName: string | null;
  callerAvatar: string | null;
};

/** Только абсолютный https-адрес без символов, которыми можно закрыть `url(` и дописать своё. */
const safeAvatar = (value: string | null): string | null =>
  value && SAFE_AVATAR_URL.test(value) ? value : null;

const safeName = (value: string | null): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed.slice(0, MAX_NAME_LENGTH) : null;
};

export const parseCallLink = (url: string | null | undefined): CallLink | null => {
  if (!url || !url.startsWith(CALL_DEEPLINK_PREFIX)) {
    return null;
  }
  try {
    const params = new URL(url).searchParams;
    const callId = params.get('callId');
    if (!callId) {
      return null;
    }
    const action = params.get('action');
    return {
      callId,
      action: action === 'answer' || action === 'decline' ? action : 'open',
      callerName: safeName(params.get('callerName')),
      callerAvatar: safeAvatar(params.get('callerAvatar')),
    };
  } catch {
    return null;
  }
};
